import {useEffect} from "react";
import {ARTICLES, BOX_SHADOWS, FONTS2} from "../../constants";
import {stateType} from "../../state";
import {ApplicationPage, articleType, useStyles} from "../ApplicationsPage";

export function SalesLeads({state}: stateType) {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	if (state.articleApplicationSelected !== ARTICLES.sales_leads) {
		state.setArticleApplicationSelected(ARTICLES.sales_leads);
	}

	const sections = [
		{id: "overview", sectionName: "Overview", content: Overview},
		{id: "thedata", sectionName: "The Data", content: TheData},
		{id: "analysis", sectionName: "Analysis", content: Analysis},
		{id: "results", sectionName: "Results", content: Results},
	];
	const article = {
		articleName: ARTICLES.sales_leads,
		sections: sections,
		created: "21-June-2021",
	} as articleType;
	return <ApplicationPage state={state} article={article}></ApplicationPage>;
}

function Overview() {
	const classes = useStyles();
	return (
		<div className={classes.sectionContent}>
			Andrew runs a media development company selling professsional video
			services to companies looking to create videos for employee
			training. Clients looking to inquire about their services fill out a
			form on their website which asks for a bunch of information about
			the potential client. Due to the volume of requests, Andrew needs a
			way to prioritize the leads before handing the off to the sales
			team.
		</div>
	);
}

function TheData() {
	const classes = useStyles();
	return (
		<div className={classes.sectionContent}>
			The information gathered from the online form as well as site data
			is as follows:
			<ul style={{marginTop: "10px", marginBottom: "10px"}}>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Client Name:
					</span>{" "}
					The name of the client who filled out the form
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Organization:
					</span>{" "}
					The organization for which the services are needed
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Industry:
					</span>{" "}
					The industry the client is in
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Your Role:
					</span>{" "}
					The current role of the client filling out the form
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Location:
					</span>{" "}
					The country and state the organization is based
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Employees:
					</span>{" "}
					The number of employees employed by the organzation
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Approximate ARR:
					</span>{" "}
					The anual recurring revenue of the organization
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Method of Contact:
					</span>{" "}
					The preferred method of communcation by the client, can be
					Telephone or Email
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Time of Website:
					</span>{" "}
					Total seconds the cliet spend on the site
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>
						Pages Visited:
					</span>{" "}
					Total number of pages visited by the client
				</li>
				<li className={classes.sectionListItem}>
					<span className={classes.sectionListItemBold}>Origin:</span>{" "}
					The origin of the client, for example Organic, Google Ads
					etc.
				</li>
			</ul>
			In addition to this data, Andrew has a past list of inquiries which
			were converted to sales. This will be used as the{" "}
			<span style={{fontWeight: "bold"}}>train</span> dataset in our
			modeling. In total we have two CSV files which look like the
			following:
			<div
				style={{
					marginTop: "20px",
					marginBottom: "-20px",
					fontWeight: 600,
					fontFamily: FONTS2,
				}}
			>
				sales_leads.csv
			</div>
			<div
				style={{
					marginTop: "40px",
					marginBottom: "-20px",
					fontWeight: 600,
					fontFamily: FONTS2,
				}}
			>
				past_sales.csv
			</div>
		</div>
	);
}

function Analysis() {
	const classes = useStyles();
	return (
		<div className={classes.sectionContent}>
			Andrew runs a media development company selling professsional video
			services to companies looking to create videos for employee
			training. Clients looking to inquire about their services fill out a
			form on their website which asks for a bunch of information about
			the potential client. Due to the volume of requests, Andrew needs a
			way to prioritize the leads before handing them off to the sales
			team.
		</div>
	);
}

function Results() {
	const classes = useStyles();
	return (
		<div className={classes.sectionContent}>
			Andrew runs a media development company selling professsional video
			services to companies looking to create videos for employee
			training. Clients looking to inquire about their services fill out a
			form on their website which asks for a bunch of information about
			the potential client. Due to the volume of requests, Andrew needs a
			way to prioritize the leads before handing the off to the sales
			team.
		</div>
	);
}
